import { useExportRawContactListMutation } from '../../../../../services/cellcast.v2';
import { ENV } from '../../../../Utils/_helpers/EnvHelper';
import { useDispatch } from 'react-redux';
import { useI18n } from '../../../../Utils/_helpers/useI18n';
import { toast } from 'react-toastify';
import { PARAM_LIMIT, PARAM_SEARCH, PARAM_SORT_BY, PARAM_SORT_ORDER } from '../constants';

export const useContactExport = (searchTerm: string, sortKey: string, sortDirection: string, pageSize: number) => {
  const [exportContact, { isLoading: isExporting }] = useExportRawContactListMutation();
  const API_DOMAIN = ENV().REACT_APP_DOMAIN;
  const dispatch = useDispatch();
  const { t } = useI18n();

  const handleExport = async () => {
    try {
      const response: any = await exportContact({
        [PARAM_LIMIT]: pageSize,
        [PARAM_SEARCH]: searchTerm,
        [PARAM_SORT_BY]: sortKey,
        [PARAM_SORT_ORDER]: sortDirection
      });
      if (response.data?.status) {
        window.open(`${API_DOMAIN}${response.data.data.downloadurl}`, '_self')
      } else {
        toast.error(response.data?.message || t('RAW_CONTACT_COLLECTION.EXPORT_ERROR'));
      }
    } catch (error) {
      toast.error(t('RAW_CONTACT_COLLECTION.EXPORT_ERROR'));
    }
  };

  return {
    handleExport,
    isExporting
  };
};
